// Component Name: EnglishAlphabetAscentLearner
import React, { useState, useEffect } from "react";
import {
  FaGlobeAmericas,
  FaVolumeUp,
  FaVolumeMute,
  FaCheckCircle,
  FaLanguage,
  FaBookReader,
  FaKeyboard
} from "react-icons/fa";

/**
 * Standard Alphabet Data with robust fallback icons/images for letters I, K, O, V, W, Z 
 * using reliable public CDN images that resolve properly.
 */
const ALPHABET_DATA = {
  A: { letter: "A", word: "Acorn", image: "https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=300&auto=format&fit=crop&q=60", usPhoneme: "/ˈeɪ.kɔːrn/", ukPhoneme: "/ˈeɪ.kɔːn/", auPhoneme: "/ˈæɪ.kɐːn/", inPhoneme: "/ˈeː.kɔːrn/" },
  B: { letter: "B", word: "Banana", image: "https://images.unsplash.com/photo-1571771894821-ce9b6c11b08e?w=300&auto=format&fit=crop&q=60", usPhoneme: "/bəˈnæn.ə/", ukPhoneme: "/bəˈnɑː.nə/", auPhoneme: "/bəˈnæː.nə/", inPhoneme: "/bəˈnɑː.nə/" },
  C: { letter: "C", word: "Carrot", image: "https://images.unsplash.com/photo-1598170845058-32b9d6a5da37?w=300&auto=format&fit=crop&q=60", usPhoneme: "/ˈker.ət/", ukPhoneme: "/ˈkær.ət/", auPhoneme: "/ˈkæɹ.ət/", inPhoneme: "/ˈkɑː.rət/" },
  D: { letter: "D", word: "Dinosaur", image: "https://images.unsplash.com/photo-1534567153574-2b12153a87f0?w=300&auto=format&fit=crop&q=60", usPhoneme: "/ˈdaɪ.nə.sɔːr/", ukPhoneme: "/ˈdaɪ.nə.sɔː/", auPhoneme: "/ˈdɑɪ.nə.sɔː/", inPhoneme: "/ˈdaɪ.nə.sɔːr/" },
  E: { letter: "E", word: "Elephant", image: "https://images.unsplash.com/photo-1557050543-4d5f4e07ef46?w=300&auto=format&fit=crop&q=60", usPhoneme: "/ˈel.ə.fənt/", ukPhoneme: "/ˈel.ɪ.fənt/", auPhoneme: "/ˈel.ə.fənt/", inPhoneme: "/ˈel.ə.fənt/" },
  F: { letter: "F", word: "Flower", image: "https://images.unsplash.com/photo-1526047932273-341f2a7631f9?w=300&auto=format&fit=crop&q=60", usPhoneme: "/ˈflaʊ.ɚ/", ukPhoneme: "/ˈflaʊ.ə/", auPhoneme: "/ˈflɑʊ.ə/", inPhoneme: "/ˈflaʊ.ər/" },
  G: { letter: "G", word: "Gorilla", image: "https://images.unsplash.com/photo-1540573133985-87b6da6d54a9?w=300&auto=format&fit=crop&q=60", usPhoneme: "/ɡəˈrɪl.ə/", ukPhoneme: "/ɡəˈrɪl.ə/", auPhoneme: "/ɡəˈrɪl.ə/", inPhoneme: "/ɡəˈrɪl.ə/" },
  H: { letter: "H", word: "House", image: "https://images.unsplash.com/photo-1518780664697-55e3ad937233?w=300&auto=format&fit=crop&q=60", usPhoneme: "/haʊs/", ukPhoneme: "/haʊs/", auPhoneme: "/hæʊs/", inPhoneme: "/haʊs/" },
  I: { letter: "I", word: "Iguana", image: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Iguana_iguana_Columbia_3.jpg/640px-Iguana_iguana_Columbia_3.jpg", usPhoneme: "/ɪˈɡwɑː.nə/", ukPhoneme: "/ɪˈɡwɑː.nə/", auPhoneme: "/ɪˈɡwɑː.nə/", inPhoneme: "/ɪˈɡwɑː.nə/" },
  J: { letter: "J", word: "Jellyfish", image: "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=300&auto=format&fit=crop&q=60", usPhoneme: "/ˈdʒel.i.fɪʃ/", ukPhoneme: "/ˈdʒel.i.fɪʃ/", auPhoneme: "/ˈdʒel.i.fɪʃ/", inPhoneme: "/ˈdʒel.i.fɪʃ/" },
  K: { letter: "K", word: "Kangaroo", image: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Red_kangaroo.jpg/640px-Red_kangaroo.jpg", usPhoneme: "/ˌkæŋ.ɡəˈruː/", ukPhoneme: "/ˌkæŋ.ɡəˈruː/", auPhoneme: "/ˌkæŋ.ɡəˈruː/", inPhoneme: "/ˌkæŋ.ɡəˈruː/" },
  L: { letter: "L", word: "Ladybug", image: "https://images.unsplash.com/photo-1589656966895-2f33e7653819?w=300&auto=format&fit=crop&q=60", usPhoneme: "/ˈleɪ.di.bʌɡ/", ukPhoneme: "/ˈleɪ.di.bʌɡ/", auPhoneme: "/ˈlæɪ.di.bʌɡ/", inPhoneme: "/ˈleː.di.bʌɡ/" },
  M: { letter: "M", word: "Monkey", image: "https://images.unsplash.com/photo-1540573133985-87b6da6d54a9?w=300&auto=format&fit=crop&q=60", usPhoneme: "/ˈmʌŋ.ki/", ukPhoneme: "/ˈmʌŋ.ki/", auPhoneme: "/ˈmɐŋ.ki/", inPhoneme: "/ˈmʌŋ.ki/" },
  N: { letter: "N", word: "Nutcracker", image: "https://images.unsplash.com/photo-1508061253366-f7da158b6d46?w=300&auto=format&fit=crop&q=60", usPhoneme: "/ˈnʌtˌkræk.ɚ/", ukPhoneme: "/ˈnʌtˌkræk.ə/", auPhoneme: "/ˈnɐtˌkræk.ə/", inPhoneme: "/ˈnʌtˌkræk.ər/" },
  O: { letter: "O", word: "Ostrich", image: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Ostrichkenya.jpg/640px-Ostrichkenya.jpg", usPhoneme: "/ˈɑː.strɪtʃ/", ukPhoneme: "/ˈɒs.trɪtʃ/", auPhoneme: "/ˈɔs.trɪtʃ/", inPhoneme: "/ˈɒs.trɪtʃ/" },
  P: { letter: "P", word: "Penguin", image: "https://images.unsplash.com/photo-1598439210625-5067c578f3f6?w=300&auto=format&fit=crop&q=60", usPhoneme: "/ˈpeŋ.ɡwɪn/", ukPhoneme: "/ˈpeŋ.ɡwɪn/", auPhoneme: "/ˈpeŋ.ɡwɪn/", inPhoneme: "/ˈpeŋ.ɡwɪn/" },
  Q: { letter: "Q", word: "Queen", image: "https://images.unsplash.com/photo-1534447677768-be436bb09401?w=300&auto=format&fit=crop&q=60", usPhoneme: "/kwiːn/", ukPhoneme: "/kwiːn/", auPhoneme: "/kwiːn/", inPhoneme: "/kwiːn/" },
  R: { letter: "R", word: "Robot", image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=300&auto=format&fit=crop&q=60", usPhoneme: "/ˈroʊ.bɑːt/", ukPhoneme: "/ˈrəʊ.bɒt/", auPhoneme: "/ˈrəʊ.bɔt/", inPhoneme: "/ˈroː.bɒt/" },
  S: { letter: "S", word: "Sunshine", image: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=300&auto=format&fit=crop&q=60", usPhoneme: "/ˈsʌn.ʃaɪn/", ukPhoneme: "/ˈsʌn.ʃaɪn/", auPhoneme: "/ˈsɐn.ʃaɪn/", inPhoneme: "/ˈsʌn.ʃaɪn/" },
  T: { letter: "T", word: "Tomato", image: "https://images.unsplash.com/photo-1592924357228-91a4daadcfea?w=300&auto=format&fit=crop&q=60", usPhoneme: "/təˈmeɪ.t̬oʊ/", ukPhoneme: "/təˈmɑː.təʊ/", auPhoneme: "/təˈmæː.təʊ/", inPhoneme: "/təˈmɑː.toʊ/" },
  U: { letter: "U", word: "Umbrella", image: "https://images.unsplash.com/photo-1534274988757-a28bf1a57c17?w=300&auto=format&fit=crop&q=60", usPhoneme: "/ʌmˈbrel.ə/", ukPhoneme: "/ʌmˈbrel.ə/", auPhoneme: "/ɐmˈbrel.ə/", inPhoneme: "/ʌmˈbrel.ə/" },
  V: { letter: "V", word: "Volcano", image: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Kilauea_crater_1991.jpg/640px-Kilauea_crater_1991.jpg", usPhoneme: "/vɑːlˈkeɪ.noʊ/", ukPhoneme: "/vɒlˈkeɪ.nəʊ/", auPhoneme: "/vɔlˈkeɪ.nəʊ/", inPhoneme: "/vɒlˈkeː.noʊ/" },
  W: { letter: "W", word: "Watermelon", image: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Watermelon_cross_BNC.jpg/640px-Watermelon_cross_BNC.jpg", usPhoneme: "/ˈwɑː.t̬ɚˌmel.ən/", ukPhoneme: "/ˈwɔː.təˌmel.ən/", auPhoneme: "/ˈwɔː.təˌmel.ən/", inPhoneme: "/ˈwɔː.tərˌmel.ən/" },
  X: { letter: "X", word: "Xylophone", image: "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=300&auto=format&fit=crop&q=60", usPhoneme: "/ˈzaɪ.ləˌfoʊn/", ukPhoneme: "/ˈzaɪ.ləˌfəʊn/", auPhoneme: "/ˈzɑɪ.ləˌfəʊn/", inPhoneme: "/ˈzaɪ.ləˌfoʊn/" },
  Y: { letter: "Y", word: "Yellow", image: "https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=300&auto=format&fit=crop&q=60", usPhoneme: "/ˈjel.oʊ/", ukPhoneme: "/ˈjel.əʊ/", auPhoneme: "/ˈjel.əʊ/", inPhoneme: "/ˈjel.oʊ/" },
  Z: { letter: "Z", word: "Zebra", image: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/Zebra_Maasai_Mara.jpg/640px-Zebra_Maasai_Mara.jpg", usPhoneme: "/ˈziː.brə/", ukPhoneme: "/ˈzeb.rə/", auPhoneme: "/ˈzeb.rə/", inPhoneme: "/ˈzeː.brə/" }
};

const ACCENTS = [
  { id: "UK", label: "British Accent", flagImg: "https://flagcdn.com/w40/gb.png", locales: ["en-GB", "en_GB", "en"] },
  { id: "US", label: "American Accent", flagImg: "https://flagcdn.com/w40/us.png", locales: ["en-US", "en_US", "en-GB", "en"] },
  { id: "AU", label: "Australian Accent", flagImg: "https://flagcdn.com/w40/au.png", locales: ["en-AU", "en_AU", "en-GB", "en"] },
  { id: "IN", label: "Indian Accent", flagImg: "https://flagcdn.com/w40/in.png", locales: ["en-IN", "en_IN", "en-GB", "en"] }
];

export default function EnglishAlphabetAscentLearner() {
  const [selectedLetter, setSelectedLetter] = useState("A");
  const [selectedAccent, setSelectedAccent] = useState("UK");
  const [isMuted, setIsMuted] = useState(false);
  const [isSpeaking, setIsSpeaking] = useState(false);

  // New state for custom user input word & dynamic active text display
  const [customWordInput, setCustomWordInput] = useState("");
  const [activeCustomWord, setActiveCustomWord] = useState(null);

  const alphabetList = Object.keys(ALPHABET_DATA);
  const currentData = ALPHABET_DATA[selectedLetter];

  // Retrieve matching phonetic representation based on selected accent
  const getAccentDetails = () => {
    const accentObj = ACCENTS.find((a) => a.id === selectedAccent) || ACCENTS[0];
    let phoneme = currentData.ukPhoneme;
    if (selectedAccent === "US") phoneme = currentData.usPhoneme;
    if (selectedAccent === "AU") phoneme = currentData.auPhoneme;
    if (selectedAccent === "IN") phoneme = currentData.inPhoneme;

    const targetWord = activeCustomWord || currentData.word;
    const targetImage = activeCustomWord
      ? "https://images.unsplash.com/photo-1579546929518-9e396f3cc809?w=300&auto=format&fit=crop&q=60"
      : currentData.image;
    return { word: targetWord, image: targetImage, phoneme, locales: accentObj.locales };
  };

  const accentDetails = getAccentDetails();

  useEffect(() => {
    speakText(false);
  }, [selectedLetter, selectedAccent, activeCustomWord]);

  const speakText = (isManualClick = false) => {
    if (isMuted && !isManualClick) return;
    if (!("speechSynthesis" in window)) return;

    window.speechSynthesis.cancel();
    setIsSpeaking(true);

    const prefixText = activeCustomWord ? `Word.` : `Letter ${currentData.letter}.`;
    const textToSpeak = `${prefixText} ${accentDetails.word}.`;
    const utterance = new SpeechSynthesisUtterance(textToSpeak);
    utterance.rate = 0.85;

    const voices = window.speechSynthesis.getVoices();
    let selectedVoice = null;

    for (let locale of accentDetails.locales) {
      selectedVoice = voices.find(
        (v) =>
          v.lang.toLowerCase() === locale.toLowerCase() ||
          v.lang.toLowerCase().startsWith(locale.substring(0, 2).toLowerCase())
      );
      if (selectedVoice) break;
    }

    if (selectedVoice) {
      utterance.voice = selectedVoice;
      utterance.lang = selectedVoice.lang;
    } else {
      utterance.lang = accentDetails.locales[0];
    }

    utterance.onend = () => setIsSpeaking(false);
    utterance.onerror = () => setIsSpeaking(false);

    if (!isMuted) {
      window.speechSynthesis.speak(utterance);
    } else {
      setIsSpeaking(false);
    }
  };

  const toggleMute = () => {
    const nextMute = !isMuted;
    setIsMuted(nextMute);
    if (nextMute && "speechSynthesis" in window) {
      window.speechSynthesis.cancel();
      setIsSpeaking(false);
    }
  };

  // Handle Custom Word Submission
  const handleCustomSubmit = (e) => {
    e.preventDefault();
    if (!customWordInput.trim()) return;
    setActiveCustomWord(customWordInput.trim());
    setCustomWordInput("");
  };

  const handleResetCustomWord = () => {
    setActiveCustomWord(null);
  };

  return (
    <div style={styles.container}>
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;800&display=swap" rel="stylesheet" />
      <style>{`
        /* Embedded Responsive Styles & Custom Animations */
        .alphabet-studio-wrapper {
          padding: 12px;
        }
        .alphabet-studio-card {
          width: 100%;
          max-width: 920px;
          border-radius: 16px;
        }
        .header-box {
          flex-direction: column;
          align-items: flex-start;
          gap: 12px;
          padding: 16px;
        }
        .header-right-mute {
          align-self: flex-end;
        }
        .workspace-grid {
          flex-direction: column;
        }
        .focus-panel-border {
          border-right: none;
          border-bottom: 1px solid #F1F5F9;
        }
        .custom-form-container {
          flex-direction: column;
          align-items: stretch;
        }
        .grid-letter-box {
          width: calc(100% / 7 - 6px);
          min-width: 32px;
          height: 38px;
        }

        /* Tablet Adjustments (640px and up) */
        @media (min-width: 640px) {
          .alphabet-studio-wrapper {
            padding: 20px;
          }
          .header-box {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding: 20px 24px;
          }
          .header-right-mute {
            align-self: auto;
          }
          .custom-form-container {
            flex-direction: row;
          }
          .grid-letter-box {
            width: 34px;
            height: 40px;
          }
        }

        /* Laptop / Desktop Adjustments (1024px and up) */
        @media (min-width: 1024px) {
          .alphabet-studio-wrapper {
            padding: 32px;
          }
          .alphabet-studio-card {
            border-radius: 20px;
          }
          .workspace-grid {
            flex-direction: row;
          }
          .focus-panel-border {
            border-bottom: none;
            border-right: 1px solid #F1F5F9;
          }
          .grid-letter-box {
            width: 30px;
            height: 36px;
          }
        }
      `}</style>

      <div style={styles.card} className="alphabet-studio-card">
        {/* Top Header */}
        <div style={styles.header} className="header-box">
          <div style={styles.headerLeft}>
            <div style={styles.iconBox}>
              <FaGlobeAmericas size={22} color="#2563EB" />
            </div>
            <div>
              <h1 style={styles.title}>Global English Alphabet Studio</h1>
              <p style={styles.subtitle}>Explore uniform kids words and listen to regional vowel shifts</p>
            </div>
          </div>
          <button onClick={toggleMute} style={styles.muteButton} className="header-right-mute" title={isMuted ? "Unmute" : "Mute"}>
            {isMuted ? <FaVolumeMute size={16} color="#DC2626" /> : <FaVolumeUp size={16} color="#2563EB" />}
            <span>{isMuted ? "Muted" : "Audio Active"}</span>
          </button>
        </div>

        {/* Accent Selection Toolbar */}
        <div style={styles.accentToolbar}>
          <span style={styles.toolbarLabel}>
            <FaLanguage style={{ marginRight: "6px" }} /> Choose Accent Region:
          </span>
          <div style={styles.accentButtonsGroup}>
            {ACCENTS.map((acc) => {
              const active = selectedAccent === acc.id;
              return (
                <button
                  key={acc.id}
                  onClick={() => setSelectedAccent(acc.id)}
                  style={{
                    ...styles.accentChip,
                    backgroundColor: active ? "#2563EB" : "#F8FAFC",
                    color: active ? "#FFFFFF" : "#334155",
                    borderColor: active ? "#1D4ED8" : "#CBD5E1",
                    boxShadow: active ? "0 4px 12px rgba(37, 99, 235, 0.25)" : "none"
                  }}
                >
                  <img src={acc.flagImg} alt={acc.label} style={styles.flagIcon} />
                  <span>{acc.label}</span>
                </button>
              );
            })}
          </div>
        </div>

        {/* Custom Word Input Toolbar */}
        <div style={styles.customWordBar}>
          <span style={styles.toolbarLabel}>
            <FaKeyboard style={{ marginRight: "6px" }} /> Test Custom Word Pronunciation:
          </span>
          <form onSubmit={handleCustomSubmit} style={styles.customFormGroup} className="custom-form-container">
            <input
              type="text"
              placeholder="Type any word (e.g., Schedule, Aluminum)..."
              value={customWordInput}
              onChange={(e) => setCustomWordInput(e.target.value)}
              style={styles.customInputText}
            />
            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
              <button type="submit" style={styles.customSubmitBtn}>
                Pronounce
              </button>
              {activeCustomWord && (
                <button
                  type="button"
                  onClick={handleResetCustomWord}
                  style={styles.customResetBtn}
                >
                  Reset to Alphabet
                </button>
              )}
            </div>
          </form>
        </div>

        {/* Alphabet Selection Grid */}
        <div style={styles.gridContainer}>
          <div style={styles.alphabetGrid}>
            {alphabetList.map((char) => {
              const isSelected = !activeCustomWord && selectedLetter === char;
              return (
                <button
                  key={char}
                  onClick={() => {
                    setActiveCustomWord(null);
                    setSelectedLetter(char);
                  }}
                  className="grid-letter-box"
                  style={{
                    ...styles.letterBox,
                    backgroundColor: isSelected ? "#2563EB" : "#FFFFFF",
                    color: isSelected ? "#FFFFFF" : "#1E293B",
                    borderColor: isSelected ? "#1D4ED8" : "#E2E8F0",
                    transform: isSelected ? "translateY(-2px)" : "none"
                  }}
                >
                  {char}
                </button>
              );
            })}
          </div>
        </div>

        {/* Main Display Area (Split Content Layout) */}
        <div style={styles.displayWorkspace} className="workspace-grid">
          {/* Left Side: Letter Focus */}
          <div style={styles.focusPanel} className="focus-panel-border">
            <span style={styles.badgeLabel}>
              {activeCustomWord ? "Custom Word Input" : "Selected Character"}
            </span>
            <div style={styles.largeLetters}>
              {activeCustomWord ? (
                <span style={{ ...styles.upperChar, fontSize: "2.2rem", wordBreak: "break-all" }}>
                  {activeCustomWord}
                </span>
              ) : (
                <>
                  <span style={styles.upperChar}>{currentData.letter}</span>
                  <span style={styles.lowerChar}>{currentData.letter.toLowerCase()}</span>
                </>
              )}
            </div>
            <div style={styles.phoneticTag}>
              Accent Phonetic Cue: <strong style={{ color: "#2563EB" }}>{activeCustomWord ? `/custom pronunciation/` : accentDetails.phoneme}</strong>
            </div>
            <button
              onClick={() => speakText(true)}
              style={{
                ...styles.playAudioBtn,
                backgroundColor: isSpeaking ? "#1E40AF" : "#2563EB"
              }}
            >
              <FaVolumeUp size={16} />
              <span>{isSpeaking ? "Pronouncing..." : `Listen (${selectedAccent})`}</span>
            </button>
          </div>

          {/* Right Side: Example Panel */}
          <div style={styles.examplePanel}>
            <div style={styles.panelHeaderRow}>
              <FaBookReader size={15} color="#2563EB" />
              <span>{activeCustomWord ? "Custom Term Testing" : "Kid-Friendly Consistent Vocabulary"}</span>
            </div>

            <div style={styles.exampleCardBox}>
              <div style={styles.exampleHeaderInfo}>
                <span style={styles.regionIndicatorBadge}>
                  {selectedAccent === "US" && "🇺🇸 American English Sound"}
                  {selectedAccent === "UK" && "🇬🇧 British English Sound"}
                  {selectedAccent === "AU" && "🇦🇺 Australian English Sound"}
                  {selectedAccent === "IN" && "🇮🇳 Indian English Sound"}
                </span>
              </div>

              <div style={styles.imageContainer}>
                <img src={accentDetails.image} alt={accentDetails.word} style={styles.wordImage} />
              </div>

              <div style={styles.wordDisplayBlock}>
                <h2 style={styles.exampleWordText}>{accentDetails.word}</h2>
                <p style={styles.wordSubText}>
                  {activeCustomWord ? (
                    <>Custom typed entry heard via <strong style={{ color: "#2563EB" }}>{selectedAccent}</strong> locale rules.</>
                  ) : (
                    <>Notice how <strong style={{ color: "#2563EB" }}>{accentDetails.word}</strong> sounds unique in this accent!</>
                  )}
                </p>
              </div>

              <div style={styles.verificationNote}>
                <FaCheckCircle size={14} color="#16A34A" />
                <span>{activeCustomWord ? "Custom Audio Synthesizer Active" : "Uniform Object for Comparison"}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#F1F5F9",
    width: "100%",
    minHeight: "100vh",
    boxSizing: "border-box",
    fontFamily: "Inter, system-ui, -apple-system, sans-serif"
  },
  card: {
    backgroundColor: "#FFFFFF",
    boxShadow: "0 10px 30px -5px rgba(0, 0, 0, 0.08)",
    border: "1px solid #E2E8F0",
    overflow: "hidden"
  },
  header: {
    background: "linear-gradient(135deg, #1E3A8A 0%, #2563EB 100%)",
    display: "flex",
    color: "#FFFFFF"
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: "12px"
  },
  iconBox: {
    backgroundColor: "#FFFFFF",
    borderRadius: "12px",
    padding: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
  },
  title: {
    margin: 0,
    fontSize: "1.2rem",
    fontWeight: 700,
    letterSpacing: "-0.2px"
  },
  subtitle: {
    margin: "2px 0 0 0",
    fontSize: "0.8rem",
    opacity: 0.85
  },
  muteButton: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    backgroundColor: "#FFFFFF",
    color: "#1E3A8A",
    border: "none",
    padding: "8px 14px",
    borderRadius: "10px",
    fontWeight: "600",
    fontSize: "0.85rem",
    cursor: "pointer",
    boxShadow: "0 2px 5px rgba(0,0,0,0.05)"
  },
  accentToolbar: {
    backgroundColor: "#F8FAFC",
    padding: "14px 16px",
    borderBottom: "1px solid #E2E8F0",
    display: "flex",
    flexDirection: "column",
    gap: "10px"
  },
  customWordBar: {
    backgroundColor: "#EFF6FF",
    padding: "14px 16px",
    borderBottom: "1px solid #DBEAFE",
    display: "flex",
    flexDirection: "column",
    gap: "10px"
  },
  toolbarLabel: {
    fontSize: "0.8rem",
    fontWeight: "700",
    color: "#475569",
    display: "flex",
    alignItems: "center",
    textTransform: "uppercase",
    letterSpacing: "0.4px"
  },
  accentButtonsGroup: {
    display: "flex",
    gap: "8px",
    overflowX: "auto",
    paddingBottom: "4px",
    WebkitOverflowScrolling: "touch"
  },
  accentChip: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "6px 12px",
    borderRadius: "10px",
    border: "2px solid",
    fontWeight: "600",
    fontSize: "0.85rem",
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "all 0.2s ease"
  },
  flagIcon: {
    width: "20px",
    height: "14px",
    objectFit: "cover",
    borderRadius: "2px",
    boxShadow: "0 1px 2px rgba(0,0,0,0.15)"
  },
  customFormGroup: {
    display: "flex",
    gap: "10px"
  },
  customInputText: {
    flex: "1 1 auto",
    padding: "8px 14px",
    borderRadius: "8px",
    border: "1px solid #CBD5E1",
    fontSize: "0.9rem",
    outline: "none",
    backgroundColor: "#FFFFFF",
    color: "#0F172A"
  },
  customSubmitBtn: {
    backgroundColor: "#2563EB",
    color: "#FFFFFF",
    border: "none",
    padding: "8px 16px",
    borderRadius: "8px",
    fontWeight: "600",
    fontSize: "0.85rem",
    cursor: "pointer",
    whiteSpace: "nowrap"
  },
  customResetBtn: {
    backgroundColor: "#E2E8F0",
    color: "#334155",
    border: "none",
    padding: "8px 16px",
    borderRadius: "8px",
    fontWeight: "600",
    fontSize: "0.85rem",
    cursor: "pointer",
    whiteSpace: "nowrap"
  },
  gridContainer: {
    padding: "12px 16px",
    backgroundColor: "#FFFFFF",
    borderBottom: "1px solid #F1F5F9"
  },
  alphabetGrid: {
    display: "flex",
    gap: "6px",
    flexWrap: "wrap",
    justifyContent: "center"
  },
  letterBox: {
    borderRadius: "8px",
    fontSize: "0.9rem",
    fontWeight: "700",
    cursor: "pointer",
    border: "2px solid",
    transition: "all 0.15s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  displayWorkspace: {
    display: "flex",
    backgroundColor: "#FFFFFF",
    minHeight: "300px"
  },
  focusPanel: {
    flex: "1 1 50%",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center"
  },
  badgeLabel: {
    fontSize: "0.75rem",
    textTransform: "uppercase",
    fontWeight: "700",
    color: "#64748B",
    letterSpacing: "0.5px"
  },
  largeLetters: {
    display: "flex",
    alignItems: "baseline",
    gap: "10px",
    margin: "8px 0",
    justifyContent: "center"
  },
  upperChar: {
    fontSize: "3.8rem",
    fontWeight: "800",
    color: "#1E3A8A",
    lineHeight: 1
  },
  lowerChar: {
    fontSize: "2.6rem",
    fontWeight: "700",
    color: "#2563EB",
    lineHeight: 1
  },
  phoneticTag: {
    fontSize: "0.85rem",
    color: "#475569",
    backgroundColor: "#F1F5F9",
    padding: "6px 12px",
    borderRadius: "8px",
    margin: "6px 0 14px 0",
    border: "1px solid #E2E8F0"
  },
  playAudioBtn: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: "#FFFFFF",
    border: "none",
    padding: "10px 18px",
    borderRadius: "12px",
    fontWeight: "600",
    fontSize: "0.85rem",
    cursor: "pointer",
    boxShadow: "0 4px 10px rgba(37, 99, 235, 0.2)"
  },
  examplePanel: {
    flex: "1 1 50%",
    padding: "20px",
    backgroundColor: "#F8FAFC",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  panelHeaderRow: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "0.75rem",
    textTransform: "uppercase",
    fontWeight: "700",
    color: "#64748B",
    marginBottom: "12px",
    letterSpacing: "0.4px"
  },
  exampleCardBox: {
    backgroundColor: "#FFFFFF",
    borderRadius: "16px",
    padding: "16px",
    border: "1px solid #E2E8F0",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
  },
  exampleHeaderInfo: {
    marginBottom: "8px"
  },
  regionIndicatorBadge: {
    backgroundColor: "#EFF6FF",
    color: "#1D4ED8",
    padding: "4px 10px",
    borderRadius: "20px",
    fontSize: "0.75rem",
    fontWeight: "700",
    border: "1px solid #DBEAFE"
  },
  imageContainer: {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    overflow: "hidden",
    marginBottom: "8px",
    border: "3px solid #E2E8F0",
    boxShadow: "0 4px 6px rgba(0,0,0,0.05)"
  },
  wordImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover"
  },
  wordDisplayBlock: {
    margin: "4px 0"
  },
  exampleWordText: {
    margin: "0 0 2px 0",
    fontSize: "1.5rem",
    fontWeight: "800",
    color: "#0F172A",
    letterSpacing: "-0.5px"
  },
  wordSubText: {
    margin: 0,
    fontSize: "0.8rem",
    color: "#64748B"
  },
  verificationNote: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    marginTop: "10px",
    backgroundColor: "#F0FDF4",
    padding: "4px 10px",
    borderRadius: "8px",
    border: "1px solid #DCFCE7",
    fontSize: "0.75rem",
    color: "#166534",
    fontWeight: "600"
  }
};